'use client';
import { noop } from '@s7/utils';

// TODO: move system
// TODO: описать назначение
var closeOnEscape = function(action, options) {
    if (options === void 0) options = {
        active: true
    };
    if (typeof action !== "function" || !options.active) {
        return options.onKeyDown || noop;
    }
    return function(event) {
        if (event.key === "Escape") {
            action(event);
            options.onTrigger == null ? void 0 : options.onTrigger.call(options);
        }
    };
};

export { closeOnEscape };
